"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailEditorConfig = void 0;
const typescript_json_serializer_1 = require("typescript-json-serializer");
const base_1 = require("../common/base");
let EmailEditorConfig = class EmailEditorConfig extends base_1.BaseModel {
    constructor(data) {
        super();
        this.clientId = data.clientId;
        this.clientSecret = data.clientSecret;
        this.grantType = data.grantType;
        this.endpoint = data.endpoint;
        this.connectSrc = data.connectSrc;
        this.frameSrc = data.frameSrc;
        this.popupClientSecret = data.popupClientSecret;
        this.popupClientId = data.popupClientId;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], EmailEditorConfig.prototype, "clientId", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], EmailEditorConfig.prototype, "clientSecret", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], EmailEditorConfig.prototype, "grantType", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], EmailEditorConfig.prototype, "endpoint", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], EmailEditorConfig.prototype, "connectSrc", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], EmailEditorConfig.prototype, "frameSrc", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], EmailEditorConfig.prototype, "popupClientSecret", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], EmailEditorConfig.prototype, "popupClientId", void 0);
EmailEditorConfig = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [Object])
], EmailEditorConfig);
exports.EmailEditorConfig = EmailEditorConfig;
